
import { useState } from 'react';



const BoldTextConverter = () => {
  const [text, setText] = useState('');
  const [formatting, setFormatting] = useState({
    isBold: false,
    isItalic: false,
  });

  // Unicode mapping for bold and italic characters
  const unicodeMap = {
    bold: {
      'a': '𝗮', 'b': '𝗯', 'c': '𝗰', 'd': '𝗱', 'e': '𝗲', 
      'f': '𝗳', 'g': '𝗴', 'h': '𝗵', 'i': '𝗶', 'j': '𝗷', 
      'k': '𝗸', 'l': '𝗹', 'm': '𝗺', 'n': '𝗻', 'o': '𝗼', 
      'p': '𝗽', 'q': '𝗾', 'r': '𝗿', 's': '𝘀', 't': '𝘁', 
      'u': '𝘂', 'v': '𝘃', 'w': '𝘄', 'x': '𝘅', 'y': '𝘆', 
      'z': '𝘇',
      'A': '𝗔', 'B': '𝗕', 'C': '𝗖', 'D': '𝗗', 'E': '𝗘', 
      'F': '𝗙', 'G': '𝗚', 'H': '𝗛', 'I': '𝗜', 'J': '𝗝', 
      'K': '𝗞', 'L': '𝗟', 'M': '𝗠', 'N': '𝗡', 'O': '𝗢', 
      'P': '𝗣', 'Q': '𝗤', 'R': '𝗥', 'S': '𝗦', 'T': '𝗧', 
      'U': '𝗨', 'V': '𝗩', 'W': '𝗪', 'X': '𝗫', 'Y': '𝗬', 
      'Z': '𝗭'
    },
    italic: {
      'a': '𝘢', 'b': '𝘣', 'c': '𝘤', 'd': '𝘥', 'e': '𝘦', 
      'f': '𝘧', 'g': '𝘨', 'h': '𝘩', 'i': '𝘪', 'j': '𝘫', 
      'k': '𝘬', 'l': '𝘭', 'm': '𝘮', 'n': '𝘯', 'o': '𝘰', 
      'p': '𝘱', 'q': '𝘲', 'r': '𝘳', 's': '𝘴', 't': '𝘵', 
      'u': '𝘶', 'v': '𝘷', 'w': '𝘸', 'x': '𝘹', 'y': '𝘺', 
      'z': '𝘻',
      'A': '𝘈', 'B': '𝘉', 'C': '𝘊', 'D': '𝘋', 'E': '𝘌', 
      'F': '𝘍', 'G': '𝘎', 'H': '𝘏', 'I': '𝘐', 'J': '𝘑', 
      'K': '𝘒', 'L': '𝘓', 'M': '𝘔', 'N': '𝘕', 'O': '𝘖', 
      'P': '𝘗', 'Q': '𝘘', 'R': '𝘙', 'S': '𝘚', 'T': '𝘛', 
      'U': '𝘜', 'V': '𝘝', 'W': '𝘞', 'X': '𝘟', 'Y': '𝘠', 
      'Z': '𝘡'
    },
    boldItalic: {
      'a': '𝙖', 'b': '𝙗', 'c': '𝙘', 'd': '𝙙', 'e': '𝙚', 
      'f': '𝙛', 'g': '𝙜', 'h': '𝙝', 'i': '𝙞', 'j': '𝙟', 
      'k': '𝙠', 'l': '𝙡', 'm': '𝙢', 'n': '𝙣', 'o': '𝙤', 
      'p': '𝙥', 'q': '𝙦', 'r': '𝙧', 's': '𝙨', 't': '𝙩', 
      'u': '𝙪', 'v': '𝙫', 'w': '𝙬', 'x': '𝙭', 'y': '𝙮', 
      'z': '𝙯',
      'A': '𝘼', 'B': '𝘽', 'C': '𝘾', 'D': '𝘿', 'E': '𝙀', 
      'F': '𝙁', 'G': '𝙂', 'H': '𝙃', 'I': '𝙄', 'J': '𝙅', 
      'K': '𝙆', 'L': '𝙇', 'M': '𝙈', 'N': '𝙉', 'O': '𝙊', 
      'P': '𝙋', 'Q': '𝙌', 'R': '𝙍', 'S': '𝙎', 'T': '𝙏', 
      'U': '𝙐', 'V': '𝙑', 'W': '𝙒', 'X': '𝙓', 'Y': '𝙔', 
      'Z': '𝙕'
    }
  };

  const handleTextChange = (e) => {
    setText(e.target.value);
  };

  const handleClear = () => {
    setText('');
    setFormatting({
      isBold: false,
      isItalic: false,
    });
  };

  const [copyButtonLabel, setCopyButtonLabel] = useState('Copy Text');

  const convertText = (input) => {
    if (formatting.isBold && formatting.isItalic) {
      return input.split('').map(char => unicodeMap.boldItalic[char] || char).join('');
    }
    if (formatting.isBold) {
      return input.split('').map(char => unicodeMap.bold[char] || char).join('');
    }
    if (formatting.isItalic) {
      return input.split('').map(char => unicodeMap.italic[char] || char).join('');
    }
    return input;
  };

  const copyToClipboard = () => {
    const textToCopy = convertText(text);
    navigator.clipboard.writeText(textToCopy);
    setCopyButtonLabel('Copied!');
    setTimeout(() => setCopyButtonLabel('Copy Text'), 1500);
  };

  const toggleFormat = (format) => {
    setFormatting((prev) => ({
      ...prev,
      [format]: !prev[format],
    }));
  };

  const getTextStyle = () => {
    return {
      fontWeight: formatting.isBold ? 'bold' : 'normal',
      fontStyle: formatting.isItalic ? 'italic' : 'normal',
    };
  };

  const calculateTextStats = (text) => {
    const totalCharacters = text.length;
    const totalCharactersWithoutSpace = text.replace(/\s+/g, '').length;
    const totalWords = text.trim() === '' ? 0 : text.trim().split(/\s+/).length;
    const totalParagraphs = text.split(/\n+/).filter(Boolean).length;
    const totalSentences = text.split(/[.!?]+/).filter(Boolean).length;

    return {
      totalCharacters,
      totalCharactersWithoutSpace,
      totalWords,
      totalParagraphs,
      totalSentences,
    };
  };

  const stats = calculateTextStats(text);
  const convertedText = convertText(text);

  return (
    <div className="container mt-5 p-4 bg-white rounded shadow-md max-w-lg mx-auto">
      <textarea
        className="w-full p-2 border rounded mb-4"
        value={text}
        onChange={handleTextChange}
        rows={8}
        style={getTextStyle()}
        placeholder="Enter your text here..."
      />

   <div className="d-flex align-items-center mb-3">
        <button
          className={`btn ${formatting.isBold ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => toggleFormat('isBold')}
        >
          Bold
        </button>
        <button
          className={`btn ${formatting.isItalic ? 'btn-primary' : 'btn-outline-secondary'}`}
          onClick={() => toggleFormat('isItalic')}
        >
          Italic
        </button>
        <button className="btn btn-primary" onClick={copyToClipboard}>
          {copyButtonLabel}
        </button>
        <button
          className="btn btn-danger"
          onClick={handleClear}
        >
          Clear
        </button>
      </div>

      {convertedText !== text && (
        <div className="mt-3 bg-gray-100 p-3 rounded">
          <strong>Converted Text:</strong>
          
     <textarea
        className="form-control mb-4"
        style={{ height: '10rem' }}
        value={convertedText}
        readOnly
        rows={10}
      />
          
          
        </div>
      )}

      <div className="mt-3 text-muted">
        <p>
          Total Characters with Space: {stats.totalCharacters} | Total Characters without Space: {stats.totalCharactersWithoutSpace} | Total Words: {stats.totalWords}
        </p>
        <p>
          Total Paragraphs: {stats.totalParagraphs} | Total Sentences: {stats.totalSentences}
        </p>
      </div>
    </div>
  );
};
export default BoldTextConverter;

